<script setup>
import { useSignUpModuleStore } from '@/stores/modules/signup/signUpStore';
import { storeToRefs } from 'pinia/dist/pinia';
import { currencyFormatter } from '../../utils';

const
    signUpStore = useSignUpModuleStore(),
    { orderSummary, address } = storeToRefs(signUpStore);

const { download, upload } = orderSummary.value['properties'].speed;
</script>

<template>
    <!-- TODO: This should be like part of the layout, just set true or false for it to appear -->
    <aside class="tw-border tw-border-solid tw-border-gray-400 tw-w-[410px] tw-py-10 tw-flex tw-flex-col tw-gap-12">
        <header class="tw-px-10">
            <h4 class="tw-text-primary tw-font-neue-kabel-bold !tw-text-[1.6em] !tw-mb-5">Order Summary</h4>
            <address>{{ address.name }}</address>
        </header>

        <div class="tw-flex tw-flex-col tw-gap-10">
            <div class="tw-flex tw-flex-col">
                <div
                    class="tw-font-neue-kabel-extrabold tw-text-[1.2em] tw-flex tw-items-center tw-justify-between
                    tw-bg-[#FF7D901A] tw-pt-2 tw-pb-1 tw-px-10"
                >
                    <span class="tw-uppercase">{{ orderSummary.ExternalName }}</span>
                    <div>{{ currencyFormatter(orderSummary.amount) }}<span class="tw-font-neue-kabel">/mth</span></div>
                </div>

                <ul class="!tw-mx-10 !tw-mt-5 tw-flex tw-flex-col tw-gap-2">
                    <li>{{ upload }} Mbps Upload</li>
                    <li>{{ download }} Mbps Download</li>
                </ul>
            </div>

            <div class="tw-flex tw-flex-col">
                <div
                    class="tw-font-neue-kabel-extrabold tw-text-[1.2em] tw-flex tw-items-center tw-justify-between
                    tw-bg-[#FF7D901A] tw-pt-2 tw-pb-1 tw-px-10"
                >
                    Package Name
                    <div>{{ currencyFormatter(orderSummary.products.Price.Amount) }}</div>
                </div>

                <ul class="!tw-mx-10 !tw-mt-5 tw-flex tw-flex-col tw-gap-2">
                    <li>{{ orderSummary.products.Name }}</li>
                </ul>
            </div>
        </div>

        <footer class="tw-bg-[#FFE8F5] tw-text-[1.2em] tw-py-6">
            <div class="tw-flex tw-items-center tw-justify-between tw-px-10 tw-font-neue-kabel-bold">
                <span class="!tw-text-[24px]">Monthly Total</span>
                <div>{{ currencyFormatter(orderSummary.monthlyTotal) }}<span class="tw-font-neue-kabel">/mth</span>
                </div>
            </div>
            <div class="tw-flex tw-items-center tw-justify-between tw-px-10 tw-font-neue-kabel-extrabold">
                <span class="!tw-text-[24px]">Total due today</span>
                {{ currencyFormatter(orderSummary.totalDueToday) }}
            </div>
        </footer>
    </aside>
</template>
